import React, { useEffect, useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchPartnerCategory, createPartnerFunction } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { useAuth } from "../../providers/AuthProvider";

export default function PartnerFunctionCreatePage() {
  const { businessDomainId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const { companyId } = useAuth();
  const t = (id) => intl.formatMessage({ id });

  const [category, setCategory] = useState(null);
  const [form, setForm] = useState({ partnerFunctionName: "", partnerFunctionDescription: "", url: "" });

  const basePath = `/strategy/${businessDomainId}/partner-categories/${categoryId}/partner-functions`;

  useEffect(() => {
    (async () => {
      try {
        const cat = await fetchPartnerCategory(categoryId);
        setCategory(cat);
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createPartnerFunction({
        companyId,
        partnerCategoryId: categoryId,
        partnerCategoryName: category?.partnerCategoryName || "",
        partnerFunctionName: form.partnerFunctionName,
        partnerFunctionDescription: form.partnerFunctionDescription || null,
        url: form.url || null,
      });
      notify.success(t("message.create.success"));
      navigate(basePath);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("partnerFunction.create.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 480 }}>
        <TextField fullWidth required sx={{ mb: 3 }}
          label={t("partnerFunction.name")}
          name="partnerFunctionName"
          value={form.partnerFunctionName}
          onChange={handleChange}
        />

        <TextField fullWidth sx={{ mb: 3 }}
          label={t("common.url")}
          name="url"
          value={form.url}
          onChange={handleChange}
          placeholder="https://..."
        />

        <TextField fullWidth multiline rows={3} sx={{ mb: 3 }}
          label={t("partnerFunction.description")}
          name="partnerFunctionDescription"
          value={form.partnerFunctionDescription}
          onChange={handleChange}
        />

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(basePath)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
